export function isDeviceMobile() {
    return window.innerWidth <= 480;
}